import { createInitialState } from "./engine.js";
import type { GameState } from "./types.js";

type Obj = Record<string, unknown>;
const isObj = (v: unknown): v is Obj => typeof v === "object" && v !== null && !Array.isArray(v);

/** Fill missing fields from defaults, keep known values. Arrays and records from input win as a whole. */
function mergeDefaults(def: unknown, val: unknown): unknown {
  if (val === undefined) return def;
  if (isObj(def) && isObj(val)) {
    const out: Obj = { ...val };
    for (const [k, v] of Object.entries(def)) out[k] = mergeDefaults(v, val[k]);
    return out;
  }
  return val;
}

/** Make any stored or imported state safe to use with the current code. */
export function migrateState(raw: unknown, now: number): GameState {
  if (!isObj(raw)) throw new Error("invalid_state");
  const def = createInitialState(now);
  const merged = mergeDefaults(def, raw) as GameState;
  // Collections must be arrays even if storage is corrupted.
  for (const k of [
    "quests",
    "reminders",
    "facts",
    "shopping",
    "inventory",
    "recent",
    "messages",
    "devices",
  ] as const) {
    if (!Array.isArray(merged[k])) (merged as unknown as Obj)[k] = [];
  }
  if (!isObj(merged.ratings)) merged.ratings = {};
  if (!isObj(merged.nudge.stats)) merged.nudge.stats = {};
  merged.version = 1;
  return merged;
}
